import React, { useLayoutEffect, useRef } from 'react';
import style from "../../css/Navlinkpage/Blog.module.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

const Blogs = () => {
  const sectionRef = useRef(null);
  const postsRef = useRef([]);
  const sidebarRef = useRef(null);

  useLayoutEffect(() => {
    if (!sectionRef.current) return;

    let ctx = gsap.context(() => {

      gsap.from(sidebarRef.current, {
        opacity: 0,
        x: 50,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sidebarRef.current,
          start: "top 90%",
          toggleActions: "play none none none",
        },
      });
    }, sectionRef);

    return () => {
      if (ctx) ctx.revert();
    };
  }, []);


  return (
    <>

      <div className={`container-fluid ${style.blogcontainer_main}`} ref={sectionRef}>
        <div className={`container ${style.blogcontainer}`}>
          <div className={`row ${style.row_main}`}>
            {/* Left Section */}
            <div className={`col-md-8 ${style.col_left}`}>
              <h2 className={style.blog_title}>DISCOVER OUR LATEST POSTS</h2>

              <div className={style.blog_post}>
                <div className={style.image_div}>

                  <img src="images\4016345.jpg" alt="New Year Event" className={style.blog_image} />
                </div>
                <div className={style.blog_content}>
                  <h3>Understanding Market Trends</h3>
                  <p>Market trends are the foundation of successful trading. Traders use technical indicators such as moving averages (SMA, EMA) and Relative Strength Index (RSI) to determine market momentum and predict price movements. Staying updated with news and macroeconomic factors also helps in identifying potential opportunities.</p>
                  <div className={style.blog_meta}>
                    <i className={` fa-regular fa-hand-point-right ${style.author_image}`} ></i>
                    <span>SWINGALGO | 29th JAN 2025</span>
                  </div>
                </div>
              </div>

              <div className={style.blog_post}>
                <div className={style.image_div}>

                  <img src="images\6262908.jpg" alt="World Cup Event" className={style.blog_image} />
                </div>
                <div className={style.blog_content}>
                  <h3>Risk Management is Key</h3>
                  <p>One of the golden rules in trading is: “Never risk more than you can afford to lose.” Setting stop-loss and take-profit levels ensures you don’t get wiped out by unexpected market swings. A common risk management technique is the 2% rule, where traders risk only 2% of their capital on a single trade.</p>
                  <div className={style.blog_meta}>
                    <i className={` fa-regular fa-hand-point-right ${style.author_image}`} ></i>
                    <span>SWINGALGO | 29th JAN 2025</span>
                  </div>
                </div>
              </div>
              <div className={style.blog_post}>
                <div className={style.image_div}>

                  <img src="images\19197351.jpg" alt="World Cup Event" className={style.blog_image} />
                </div>
                <div className={style.blog_content}>
                  <h3>The Power of Price Action Trading</h3>
                  <p>Price action trading involves analyzing raw price movement without relying heavily on indicators. It focuses on patterns like support and resistance, candlestick formations, and trendlines. Many professional traders use this approach to make real-time trading decisions.</p>
                  <div className={style.blog_meta}>
                    <i className={` fa-regular fa-hand-point-right ${style.author_image}`} ></i>
                    <span>SWINGALGO | 29th JAN 2025</span>
                  </div>
                </div>
              </div>
              <div className={style.blog_post}>
                <div className={style.image_div}>

                  <img src="images\people-tablet-with-bar-graph.jpg" alt="World Cup Event" className={style.blog_image} />
                </div>
                <div className={style.blog_content}>
                  <h3>Backtesting and Continuous Learning</h3>
                  <p>Professional traders backtest their strategies on historical data to analyze their effectiveness before executing them in live markets. Continuous learning through market analysis, books, and trading journals is essential for long-term success.</p>
                  <div className={style.blog_meta}>
                    <i className={` fa-regular fa-hand-point-right ${style.author_image}`} ></i>
                    <span>SWINGALGO | 29th JAN 2025</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div ref={sidebarRef} className={`col-md-4 ${style.col_right}`}>
              {/* <div className={style.search_bar}>
              <input type="text" placeholder="Search..." className={style.search_input} />
            </div> */}

              <div className={style.top_posts}>
                <h3>TOP POSTS</h3>
                <ul>
                  <li>Use Technical Indicators for Confirmation</li>
                  <li>Welcome To Trading</li>
                  <li>Psychology of Trader</li>
                  <li>Everything you need to know about... Trading</li>
                  <li>How to... Sell & Buy with price action</li>
                </ul>
              </div>

              <div className={style.follow_us}>
                <h3>FOLLOW US</h3>
                <div className={style.social_icons}>
                  <i className="fab fa-twitter"></i>
                  <i className="fab fa-linkedin"></i>
                  <i className="fab fa-facebook"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Blogs;
